module.exports = __webpack_public_path__ + "img/collection-engagementRingsEssentials@2x.625f64e.webp";